import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BmPaymentPlanService} from '../../service/bm-payment-plan.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Contract} from "../../model/contract.interface";

@Component({
    selector: 'bm-payment-plan',
    templateUrl: './bm-payment-plan.component.html',
    styleUrls: ['./bm-payment-plan.component.scss'],
    standalone: false
})
export class BmPaymentPlanComponent implements OnInit, OnDestroy {

    @Input() dunningId!: number;

    selectedContract: Contract | null = null;

    activeTab: string = '0';


    busy: boolean = false;
    initialized: boolean = false;
    error: string | null = null;

    private destroy$ = new Subject<void>();

    constructor(protected paymentPlanService: BmPaymentPlanService) {
    }

    async ngOnInit(): Promise<void> {
        await this.initComponent();
    }

    /**
     * Initialize component and load dunning data
     */
    async initComponent(): Promise<void> {
        if (!this.dunningId) {
            this.error = 'No dunning ID provided';
            return;
        }

        this.busy = true;
        this.error = null;

        try {
            await this.paymentPlanService.initializePaymentPlan(this.dunningId);
            this.initialized = true;
        } catch (err) {
            this.error = 'Failed to load payment plan data';
            console.error('Error initializing payment plan:', err);
        } finally {
            this.busy = false;
        }

        this.paymentPlanService.selectedContract$
            .pipe(takeUntil(this.destroy$))
            .subscribe(contract => {
                this.selectedContract = contract;

                if (contract) {
                    this.activeTab = '1';
                } else {
                    this.activeTab = '0';
                }

            });

    }

    closeContractToolbar(): void {
        this.paymentPlanService.clearSelectedContract();

        this.activeTab = '0';
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
